module.exports = {
      id: "login-facebook-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#login-facebook",
      toString: function () {
        return this.url;
      }
    }